import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "RequestsList",
      component: () => import("@/views/pages/requests/requests-list.vue"),
      meta: {
        pageTitle: "قائمة الطلبات",
        breadcrumb: [
          {
            text: "قائمة الطلبات",
            active: true,
          },
        ],
      },
    },
    {
      path: "/view-request/:id",
      name: "ViewRequest",
      component: () => import("@/views/pages/requests/view-request.vue"),
      meta: {
        pageTitle: "عرض الطلب",
        breadcrumb: [
          {
            text: "عرض الطلب",
            active: true,
          },
        ],
      },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/pages/auth/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/error-404",
      name: "error-404",
      component: () => import("@/views/pages/error/Error404.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
